import { useMemo } from 'react';
import { spliced } from '../../common/util/spliced';
import { SearchResultItem } from '../types';

const ADS_POSITION = 4;
const ADS_POSITION_2 = 11;

export const useGamAds = (searchResults: SearchResultItem[]) =>
  useMemo(() => {
    let splicedSearchResults: SearchResultItem[] = spliced<SearchResultItem>(
      searchResults,
      ADS_POSITION,
      0,
      { type: 'gam-ad', id: '1' },
    );

    const hasSuggestion: boolean = searchResults.some(x => x.type === 'suggestion');
    const secondAdSearchResultsThreshold = hasSuggestion ? 11 : 10;

    if (searchResults.length > secondAdSearchResultsThreshold) {
      const adsPosition2 = hasSuggestion ? ADS_POSITION_2 + 1 : ADS_POSITION_2;

      splicedSearchResults = spliced<SearchResultItem>(splicedSearchResults, adsPosition2, 0, {
        type: 'gam-ad',
        id: '2',
      });
    }

    return splicedSearchResults;
  }, [searchResults]);
